import React from 'react';

/**
 * Icon inside circular modal close buttons.
 * Prefer this over Unicode ✕/✖ — those glyphs often fail with Lato (missing glyph → blank circle).
 */
const ModalCloseIcon = ({ style, className = '' }) => (
  <i
    className={`fas fa-times ${className}`.trim()}
    aria-hidden="true"
    style={{ ...style }}
  />
);

export default ModalCloseIcon;
